const getData = adapter => key => {
  return adapter.callAction('getData', { key })
}

export default getData
